<template>
  <div class="headerpage">
      <div class="topHeader">
        <div class="topHeaderCenter">
          <!-- <div @click="toAdmin(4)">
            <i class="iconfont icon-shezhixitongshezhigongnengshezhishuxing"></i>
          </div>
          <div  @click="toAdmin(3)">
            <i class="iconfont icon-shangchuanwenjian"></i>
          </div>
          <div  @click="toAdmin(2)">
            <i class="iconfont icon-shoucang"></i>
          </div>
          <div class="user"  @click="toAdmin(1)">
            <i class="iconfont icon-yanshengguanliyuan"></i>
            <div>管理员</div>
          </div> -->
        </div>
        
      </div>
      <div class="searchWrapper">
        <div>
          <div class="logoname" @click="toHome()">
            <img src="../assets/img/logo.png" >
          </div>
          <div class="searchbox">
              <div class="classify" @mouseenter="mouseOverClassifyFn"
                @mouseleave="mouseLeaveClassifyFn">
                  <span class="el-dropdown-link">
                    {{topicLabel}}<i class="el-icon-caret-bottom el-icon--right"></i>
                  </span>
                
                <div v-show="showclassifybox" class="classifybox">
                  <el-tree
                    :data="classifydata"
                    show-checkbox
                    default-expand-all
                    node-key="code"
                    ref="tree"
                    highlight-current
                    @check="handleTreeCheckChange"
                    :props="defaultProps">
                  </el-tree>
                </div>
              </div>
            <div class="searchinp">
              <el-input placeholder="标题，关键字，全文" v-model="searchInput" class="input-with-select" @keyup.enter.native="searchFn()">
              </el-input>
              <el-button class="input-with-bottom" @click="searchFn()">
                <i class="iconfont icon-sousuo2"></i>
                <span>搜索</span>
                </el-button>
            </div>
          </div>
          <div class="checkbox">
            <el-checkbox-group v-model="checkList">
              <el-checkbox :label="index" v-for="(item,index) in checkListData" :key="index">{{item.itemText}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="tabswitch" v-show="showtabswitch">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="首页" name="/Home" style="color:#f00;"></el-tab-pane>
              <el-tab-pane label="研究单元" name="/ResearchUnit"></el-tab-pane>
              <el-tab-pane label="专题分类" name="/Theme"></el-tab-pane>
              <el-tab-pane label="知识图谱" name="/Atlas"></el-tab-pane>
            </el-tabs>
          </div>
        </div>

      </div>
  </div>
</template>

<script>
import api from "@/api/home.js"
import Vue from 'vue'
import {
  Input,
  button,
  CheckboxGroup,Checkbox,Tabs,TabPane
  } from 'element-ui';
Vue.use(Input);
Vue.use(button);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Tabs);
Vue.use(TabPane);
import commonUrl from '@/assets/js/baseurl'
export default {
  name: 'Header',
  props: {
    msg: String
  },
  components:{
  },
  
  watch:{
    $route(to,from){
      if(to.path){
        this.activeName=to.path;
        if(this.activeName=='/Search'){
          this.showtabswitch=false;
        }else{
          this.showtabswitch=true;
        }
      }
    }
  },
  data(){
    return {
      searchInput:'',
      checkList:[],
      checkListData:[],
      activeName: '/Home',
      showtabswitch:true,
      showclassifybox:false,
      classifydata: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      topicCodes:'',
      topicLabel:'知识专题',
    }
  },
  created(){
    this.activeName=this.$route.path;
    if(this.activeName=='/Search'){
      this.showtabswitch=false;
    }
      this.getloadTreeData();
      this.getDictItemList();
  },
  methods: {
    getDictItemList(){
      api.getDictItemList({
        dictId:'1415574243599777794',field:'id,,itemText,itemValue,action',pageNo:1,pageSize:10
      })
      .then((res)=>{
        if(res.code==0&&res.result&&res.result.records.length>0){
          this.checkListData=res.result.records;
        }
      }).catch((err) => {
          });
    },
    getloadTreeData(){
        //专题分类
        let params = {
          async: false,
          pcode: ""
        };
        api.getloadTreeData(params)
          .then((res)=>{
            let treedatadiy=[]
            if(res.code==0&&res.result.length>0){
              this.classifydata= this.diyTreeDataFn(res.result);
              
            }
          }).catch((err) => {
          });
      },
      diyTreeDataFn(data){
        let that=this;
        let treearr=[]
        for(let i in data){
          if(data[i].children&&data[i].children.length>0){
            
            treearr.push({
              label: data[i].title,
              code:data[i].code,
              children:that.diyTreeDataFn(data[i].children)
            })
          }else{
            treearr.push({
              label: data[i].title,
              code:data[i].code,
            })
          }
        }
          return treearr
      },
    handleTreeCheckChange(data,list) {
      console.log(data,list)
      if(list.checkedKeys.length==0){
        this.topicCodes='';
        this.topicLabel='知识专题';
      }else{
        if (list.checkedKeys.length >= 2) {
              //单选实现
              this.$refs.tree.setCheckedKeys([data.code]);
       }
          this.topicCodes=data.code;
          this.topicLabel=data.label;
      }
      if(this.activeName=='/Search'){
        this.searchDoc()
      }
    },
    handleClick(tab, event) {
      if(tab.index==0){
        this.$router.push('/Home');
      }else if(tab.index==1){
        this.$router.push('/ResearchUnit');
      }else if(tab.index==2){
        this.$router.push('/Theme');
      }else if(tab.index==3){
        this.$router.push('/Atlas');
      }
    },
    toHome(){
      if(this.$route.name!='Home'){
        this.$router.push('/Home');

      }
    },
    toAdmin(idx){
      if(idx==2){
          window.open(commonUrl.baseUrl+'/km/filemanagement/KmDocFavouriteList',"_blank");
      }else if(idx==3){
          window.open(commonUrl.baseUrl+'/km/filemanagement/DraftsList',"_blank");
      }else if(idx==4){
          window.open(commonUrl.baseUrl+'/dashboard/analysis',"_blank");
      }else{
          window.open(commonUrl.baseUrl+'/dashboard/analysis',"_blank");
      }
    },
    mouseOverClassifyFn(){
      this.showclassifybox=true;
    },
    mouseLeaveClassifyFn(){
      // console.log(e)
      this.showclassifybox=false;

    },
    searchFn(){
      console.log(this.checkList,195)
      if(this.$route.name!='Search'){

        this.$router.push({name:'Search'});
      }
      this.searchDoc()

    },
    searchDoc(){
      let params={
        column: '_score',
        order:'desc',
        field: 'id,,,title,category_dictText,businessType_dictText,action',
        pageNo: 1,
        pageSize: 1000,
        // content:this.searchInput,
        // title: this.searchInput,
        // keywords: this.searchInput,
        // advSearchFlag: 0,
        // category: this.checkList.toString(),
        // topicCodes: this.topicCodes,
      }
      if(this.searchInput){
        params.content=this.searchInput;
        params.title=this.searchInput;
        params.keywords=this.searchInput;
        params.advSearchFlag=0;
      }
      if(this.checkList.toString()){
        params.category=this.checkList.toString();
      }
      if(this.topicCodes){
        params.topicCodes=this.topicCodes;
      }
      api.searchDoc(params).then((res)=>{
        if(res.code==200){
        console.log('res:',res)
          // this.searchResult=res.result;
          this.$store.dispatch('updataSearchData',res.result)
        }else{
          this.$message.error('系统错误！请稍后再试');
        }
      }).catch((err) => {
          });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  .headerpage{
    color: #333333;
    .topHeader{
      // width: 1200px;
      height: 48px;
      background: #fcfcfc;
      .topHeaderCenter{
        width: 1200px;
        height: 48px;
        margin: 0 auto;
        cursor: pointer;
        &>div{
          height: 48px;
          line-height: 48px;
          float: right;
          i{
            color:#376EF4;
          }
          margin-right: 20px;
        }
        .user{
          i{
            margin-right: 8px;
          }
          // width: 86px;
           div{float: right;margin-right: 8px;}
          font-size: 16px;
          font-weight: 400;
          color: #343434;
        }
      }
    }
    .searchWrapper{
      position: relative;
      height: 226px;
      background: #FCFCFC;
      &>div{
        width: 1200px;
        margin: 0 auto;
        // overflow: hidden;
        padding-top: 28px;
      }
      .logoname{
        width: 235px;
        margin: 0px auto;
        margin-bottom: 28px;
        height: 35px;
        // line-height: 30px;
        cursor: pointer;
        img{
          width: 100%;
          height: 100%;
        }
        // &>div{
        //   float: right;
        //   font-size: 24px;
        //   font-weight: 400;
        //   color: #0A1E2D;
        // }
      }
      .searchbox{
        width: 800px;
        height: 40px;
        background: #FFFFFF;
        border: 2px solid #376EF4;
        border-radius: 7px;
        margin: 0 auto;
        position: relative;
        z-index: 6;
        .classify{
          width: 200px;
          .el-dropdown-link {
          width: 121px;
          height: 24px;
          margin-top: 7px;
          border-right: 1px solid #376EF4;
          text-align: center;
          display: block;
          // float: left;
            cursor: pointer;
            color: #376EF4;
          }
          .el-icon-arrow-down {
            font-size: 12px;
          }
          .iconfont{color: #376EF4;}
        }
        .classifybox{
          // position: absolute;
          // top: 44px;
          // left: 0;
          margin-top: 10px;
          background-color: #fff;
          width: 200px;
          border: 1px solid #E6E6E6;
          z-index: 3;
          box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
          -webkit-transform: translate3d(0, 0, 0);
          padding: 10px 10px 10px 4px;
        }
        .searchinp{
          width: 674px;
          position: absolute;
          top: 0;
          right: 0;
          overflow: hidden;
          .input-with-select{
            width: 570px;
            height: 36px;
          }
          .input-with-select .el-input__inner{
              border: none;
              height: 36px;
            }
            .input-with-bottom{
              width: 108px;
              border: none;
              height: 40px;
              background: #376EF4;
              border-radius: 0;
              // border-radius: 0px 5px 5px 0px;
              color: #FFFFFF;
              position: absolute;
              top: -1px;
              right: 0;
              font-size: 15px;
              .iconfont{
                // fs
                margin-right: 8px;
              }
            }
        }
      }
      .checkbox{
        width: 800px;
        height: 40px;
        margin: 0 auto;
        margin-top: 12px;
        // padding-left: 40px;
        text-align: center;
        .el-checkbox__label{
          color: #333333;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
              background-color: #376EF4;
              border-color: #376EF4;
        }
      }
      .tabswitch{
        width: 1200px;
        border-bottom: 1px solid #CDCDCD;
        position: absolute;
        bottom: 0;
        .el-tabs{
        width: 800px;
        margin: 0 auto;
        padding-left: 34px;
        }
        .el-tabs__header{
          margin: 0;
        }
        .el-tabs__nav-wrap::after{
          height: 0px;
          background: #CDCDCD;
        }
        .el-tabs__item{
          font-size: 16px;
          font-weight: 400;
          // color: #333333;
          padding: 0 40px;
        }
        .el-tabs__item:hover{
          color: #376EF4;
        }
        .el-tabs__item.is-active{
          font-weight: 500;
          color: #376EF4;
          font-size: 18px;
        }
        .el-tabs__active-bar{
          height: 3px;
          background-color: #376EF4;
        }
        .el-tabs__nav{
          margin-left: 140px;
        }
        
      }
    }
  }
</style>